import { c as _c } from "react/compiler-runtime";
import { NextApiSwrProvider } from '@newfront-insurance/next-api-swr';
import type { AuthProviderContext, AuthProviderProps } from '@newfront-insurance/next-auth';
import type { Provider } from '@newfront-insurance/react-provision';
import { useProvider } from '@newfront-insurance/react-provision';
import * as React from 'react';
import type { JSX } from 'react';
interface Props {
  children: React.ReactNode;
  authProvider: Provider<AuthProviderContext, AuthProviderProps>;
}
export function AuthNextSwrProvider(t0) {
  const $ = _c(3);
  const {
    children,
    authProvider
  } = t0;
  const {
    getAccessTokenCallback
  } = useProvider(authProvider);
  let t1;
  if ($[0] !== children || $[1] !== getAccessTokenCallback) {
    t1 = <NextApiSwrProvider authToken={getAccessTokenCallback}>{children}</NextApiSwrProvider>;
    $[0] = children;
    $[1] = getAccessTokenCallback;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}